"use client";

import { useEffect } from "react";
import { useQuery } from "@apollo/client/react";
import * as Sentry from "@sentry/nextjs";

import { queries } from "@/api";
import { useLogger } from "@/contexts/logger";
import { useActiveTenant } from "@/tenants/TenantProvider";

/**
 * Attaches the logged-in investor to Sentry so captured errors can be traced
 * back to a specific user — the core observability gap from incident-37
 * (APP-23988). Reads the account from the Apollo cache (already populated by
 * InitializeApp's network-only INITIALIZE_APP query) rather than issuing its own
 * request, and clears the user on logout (handled by LoggerProvider's
 * useSessionRemovedListener). Mirrors admin-app's SetLoggerUser.
 */
const SetLoggerUser = () => {
	const { setUser } = useLogger();
	const tenant = useActiveTenant();

	// cache-only: never triggers a network request — InitializeApp owns fetching.
	const { data } = useQuery(queries.INITIALIZE_APP, {
		fetchPolicy: "cache-only",
	});

	const account = data?.account;
	const id = account?.id;
	const email = account?.email;
	const tenantId = tenant?.tenantId;

	useEffect(() => {
		if (id) {
			setUser({ id, ...(email && { email }) });
		}
	}, [id, email, setUser]);

	useEffect(() => {
		if (tenantId) {
			Sentry.setTag("tenant", tenantId);
		}
	}, [tenantId]);

	return null;
};

export default SetLoggerUser;
